import React from 'react'
import { PropTypes } from 'prop-types'
import { css, StyleSheet } from 'aphrodite'
import { COLOR_GREY_050, COLOR_GRAY_DARK } from '../../../lib/colors'

const styles = StyleSheet.create({
  header: {
    backgroundColor: COLOR_GREY_050,
    padding: '20px 10px',
    width: '150px',
  },
  headerText: {
    fontSize: 'small',
    fontWeight: 700,
    color: COLOR_GRAY_DARK,
  },
})

const TableHeadItem = ({ item }) => {
  return (
    <td title={item} className={css(styles.header)}>
      <span className={css(styles.headerText)}>{item.toUpperCase()}</span>
    </td>
  )
}

TableHeadItem.propTypes = {
  item: PropTypes.string,
}

export default TableHeadItem
